// Gravidanza — sezione dedicata pulita, con badge IN STUDIO · ONLINE.
// Testi/foto sovrascrivibili via /admin/landing-config.
import { useLandingConfig } from "@/hooks/useLandingConfig";
import SafeImg from "@/components/landing/SafeImg";

const DEFAULT_PREGNANCY_PHOTO = "https://thb.tildacdn.net/tild6565-6336-4534-a236-373532663434/-/resize/1200x/DSC06065.jpg";

export default function LandingPregnancy() {
  const { T } = useLandingConfig();
  const eyebrow = T("texts.pregnancy.eyebrow", "Pilates in gravidanza");
  const t1 = T("texts.pregnancy.title_line1", "Dolce, sicuro,");
  const t2 = T("texts.pregnancy.title_line2", "pensato per te.");
  const italicWord = T("texts.pregnancy.title_italic_word", "pensato per te");
  const badgeStudio = T("texts.pregnancy.badge_studio", "In studio");
  const badgeOnline = T("texts.pregnancy.badge_online", "Online");
  const p1 = T("texts.pregnancy.paragraph1", "Un allenamento pensato appositamente per le future mamme. Piccoli attrezzi che garantiscono supporto e comfort in ogni fase.");
  const p2 = T("texts.pregnancy.paragraph2", "Ogni sessione rispetta i ritmi del corpo, migliora la postura e rinforza il pavimento pelvico. Per accompagnarti anche a casa, un kit omaggio con esercizi sicuri.");
  const chip1 = T("texts.pregnancy.chip1", "Percorso pre-parto");
  const chip2 = T("texts.pregnancy.chip2", "Percorso post-parto");
  const chip3 = T("texts.pregnancy.chip3", "Classi da 3 · attrezzi dedicati");
  const photo = T("images.pregnancy_photo", "");

  const renderTitleLine = (line) => {
    if (!italicWord || !line?.toLowerCase().includes(italicWord.toLowerCase())) return line;
    const idx = line.toLowerCase().indexOf(italicWord.toLowerCase());
    return (
      <>
        {line.slice(0, idx)}
        <span className="font-editorial text-mauve">{line.slice(idx, idx + italicWord.length)}</span>
        {line.slice(idx + italicWord.length)}
      </>
    );
  };

  return (
    <section data-testid="landing-pregnancy" id="gravidanza" className="relative overflow-hidden bg-accent/40">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-32 md:py-40 grid md:grid-cols-12 gap-12 md:gap-20 items-center">
        {/* Foto sinistra */}
        <div className="md:col-span-6 relative">
          <div className="aspect-[3/4] overflow-hidden rounded-[2rem]">
            <SafeImg
              src={photo}
              fallback={DEFAULT_PREGNANCY_PHOTO}
              alt="Pilates gravidanza — Epic Flow"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Testo destra */}
        <div className="md:col-span-6">
          <div className="text-[10px] uppercase tracking-[0.42em] text-foreground/50 mb-8 flex items-center gap-3">
            <span className="w-10 h-px bg-foreground/40" />
            {eyebrow}
          </div>

          <div className="inline-flex items-center gap-3 mb-10">
            <span className="text-[10px] uppercase tracking-[0.32em] px-4 py-2 rounded-full bg-primary text-primary-foreground">{badgeStudio}</span>
            <span className="text-xs text-foreground/40">·</span>
            <span className="text-[10px] uppercase tracking-[0.32em] px-4 py-2 rounded-full bg-secondary text-secondary-foreground">{badgeOnline}</span>
          </div>

          <h2 className="font-serif-display font-normal text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-foreground">
            {renderTitleLine(t1)}
            <br />
            {italicWord ? renderTitleLine(t2) : <span className="font-editorial text-mauve">{t2}</span>}
          </h2>

          <div className="mt-10 space-y-5 text-lg leading-relaxed text-foreground/70 font-light max-w-lg">
            <p>{p1}</p>
            <p>{p2}</p>
          </div>

          <div className="mt-12 flex flex-wrap gap-3">
            <div className="px-5 py-3 rounded-full border border-mauve/40 text-sm text-foreground/80">{chip1}</div>
            <div className="px-5 py-3 rounded-full border border-mauve/40 text-sm text-foreground/80">{chip2}</div>
            <div className="px-5 py-3 rounded-full border border-mauve/40 text-sm text-foreground/80">{chip3}</div>
          </div>
        </div>
      </div>
    </section>
  );
}
